// extracted by mini-css-extract-plugin
export var author = "blogsCarousel-module--author--09d17";
export var awardLogo = "blogsCarousel-module--awardLogo--e7d4a";
export var blogSec = "blogsCarousel-module--blogSec--3d9cf";
export var category = "blogsCarousel-module--category--a98b7";
export var items = "blogsCarousel-module--items--82ccf";
export var learnBtn = "blogsCarousel-module--learnBtn--6fbe1";
export var seeall = "blogsCarousel-module--seeall--6e3cc";
export var title = "blogsCarousel-module--title--0f877";